import { graphql } from "@opensea/graphql"

export const readOrderCreationErrorFragment = graphql(`
  fragment readOrderCreationError on OrderCreationMutationResponse {
    __typename
    ... on OrderCreationErrorResponse {
      errors {
        ... on TransactionError {
          message
        }
      }
    }
  }
`)
